import React from 'react'
import PropTypes from 'prop-types'
import { TextBlock, TextRow } from 'react-placeholder/lib/placeholders'
import styled from 'styled-components'

export const PlaceholderWrapper = styled.div`
  .show-loading-animation.rect-shape,
  .show-loading-animation.round-shape,
  .show-loading-animation.text-row,
  .show-loading-animation .rect-shape,
  .show-loading-animation .round-shape,
  .show-loading-animation .text-row {
    animation: react-placeholder-pulse 1.5s infinite;
  }

  @keyframes react-placeholder-pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`

const TextWrapper = styled.div`
  margin-left: 16px;
  width: 20%;
`

const AdCountPlaceholder = styled.div`
  width: 10%;
  margin-left: auto;
`

export const ListTextPlaceholder = ({ color, marginTop }) => (
  <React.Fragment>
    <TextWrapper>
      <TextBlock color={color} rows={2} />
      <TextRow style={{ marginTop }} color={color} />
    </TextWrapper>
    <AdCountPlaceholder>
      <TextRow color={color} />
    </AdCountPlaceholder>
  </React.Fragment>
)

ListTextPlaceholder.propTypes = {
  color: PropTypes.string,
  marginTop: PropTypes.string,
}
